import React from 'react'
import { withTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import qs from 'qs'
import ReactCodeInput from 'react-code-input'
import keydown from 'react-keydown'

import { API__AUTH, API__USER } from '../api'

import { IconLogoFull, IconPlumage, IconEyeOpen, IconEyeClose } from '../svg'
import CheckPromoImg from '../images/png/checkPromo.png'

import GithubLogo from '../images/png/social/github-logo.png'
import FacebookLogo from '../svg/social/facebook.svg'
import GoogleLogo from '../svg/social/google.svg'

import { AUTH__LOGIN_REFRESH } from '../store/actions'
import { UTILS__ROUTER__add_query, UTILS__ROUTER__remove_query } from '../utils/router'

import { UTILS__VALIDATOR__is_email, UTILS__VALIDATOR__is_int } from '../utils/validator'
import Toast from '../common/components/Toast/Toast'
import { compose } from 'redux'
import ErrorLogging from '../common/services/ErrorLogging'

const getSocialAuthLink = (provider, successRedirectLink) => {
    return `${process.env.REACT_APP_BACKEND_URL}/api/oauth2/authorize/${provider}?redirect_uri=${
        window.location.origin
    }/oauth2/redirect${
        successRedirectLink ? `?success_redirect=${successRedirectLink.pathname + successRedirectLink.search}` : ''
    }`
}

const SocialAuthBlock = ({ action, successRedirectLink, t }) => (
    <div className="auth-social-block">
        {process.env.REACT_APP_BACKEND_URL === 'https://api.dev.interacty.me' && (
            <div className="dev-block">
                <a
                    // Example: `${process.env.REACT_APP_BACKEND_URL}/api/oauth2/authorize/github?redirect_uri=${window.location.origin}/oauth2/redirect`
                    href={getSocialAuthLink('github', successRedirectLink)}
                    title="GitHub"
                >
                    <img src={GithubLogo} alt="GithubLogo" />
                </a>
            </div>
        )}
        <div className="list">
            <a href={getSocialAuthLink('google', successRedirectLink)} title="Google" data-test="signup-with-google">
                <img src={GoogleLogo} alt="GoogleLogo" />
                <p>{action === 'authentication' ? t('Sign in with Google') : t('Sign up with Google')}</p>
            </a>
            <a
                href={getSocialAuthLink('facebook', successRedirectLink)}
                title="Facebook"
                data-test="signup-with-facebook"
            >
                <img src={FacebookLogo} alt="FacebookLogo" />
                <p>{action === 'authentication' ? t('Sign in with Facebook') : t('Sign up with Facebook')}</p>
            </a>
        </div>
        <div className="divider" data-text={t('_common.or')}></div>
    </div>
)

class Auth extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            action: null,
            actions: ['authentication', 'activation', 'registration', 'password_recovery'],

            activation: {
                is_loading: false,
                is_success: false,
            },

            form_1: {
                is_loading: false,
                show_password: false,
                data__tmp: {
                    email: '',
                    password: '',
                },
                error: {
                    email: '',
                    password: '',
                },
            },
            password_recovery: {
                step: 1,
                is_success: false,
            },
            form_2_1: {
                is_loading: false,
                data__tmp: {
                    email: '',
                },
                error: {
                    email: '',
                },
            },
            form_2_2: {
                is_loading: false,
                show_password: false,
                data__tmp: {
                    password: '',
                    code: '',
                },
                error: {
                    password: '',
                    code: '',
                },
            },
            registration: {
                step: 1,
                is_success: false,
            },
            form_3: {
                is_loading: false,
                show_password: false,
                roles: [],
                data__tmp: {
                    first_name: '',
                    last_name: '',
                    company: '',
                    role: {
                        name: props.t('_common.select'),
                        placeholder: true,
                        value: null,
                    },
                    email: '',
                    password: '',
                    news_subscription: true,
                },
                error: {
                    first_name: '',
                    last_name: '',
                    company: '',
                    role: '',
                    email: '',
                    password: '',
                    news_subscription: '',
                },
            },

            resend_email: {
                attempt: 0,
                isLoading: false,
                isSuccess: false,
                isError: false,
            },

            socialSuccessRedirect: null,
        }
        this.base_state = this.state
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    async componentDidMount() {
        this._isMounted = true

        try {
            // Check location state
            const { location } = this.props
            if (location.state) {
                const { toast, to, from } = location.state
                if (toast) {
                    const {
                        toast: { type, title, message, time = null },
                    } = location.state
                    Toast(type, {
                        title,
                        message,
                        time,
                    })
                }
                if (to) {
                    await this.setState({
                        socialSuccessRedirect: to,
                    })
                } else if (from) {
                    await this.setState({
                        socialSuccessRedirect: from,
                    })
                }
            }

            const query_params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

            // Actions
            const query_params__action = query_params.action
            const { actions } = this.state
            if (typeof query_params__action !== 'undefined') {
                if (actions.indexOf(query_params__action) !== -1) {
                    await this.setState({
                        action: query_params__action,
                    })
                } else {
                    await this.setState({
                        action: actions[0],
                    })
                    UTILS__ROUTER__remove_query('action', {
                        history: this.props.history,
                        location: this.props.location,
                    })
                }
            } else {
                await this.setState({
                    action: actions[0],
                })
            }

            // TODO added as HOTFIX for ENGA-1705
            if (!!query_params.activationCode)
                this.setState({ action: 'activation'})

            const { action } = this.state

            if (action === 'activation') {
                const query_params__activation_code = query_params.activationCode
                if (typeof query_params__activation_code !== 'undefined') {
                    await this.setState(prevState => ({
                        activation: {
                            ...prevState.activation,
                            is_loading: true,
                            is_success: false,
                        },
                    }))
                    await this.activateUser(query_params__activation_code)
                } else {
                    UTILS__ROUTER__remove_query('action', {
                        history: this.props.history,
                        location: this.props.location,
                    })
                    await this.setState({
                        action: actions[0],
                    })
                }
            } else {
                UTILS__ROUTER__remove_query('activationCode', {
                    history: this.props.history,
                    location: this.props.location,
                })
            }
        } catch (err) {
            console.error(err)
        }
    }

    @keydown(['F1'])
    hack() {
        if (process.env.REACT_APP_BACKEND_URL === 'https://api.dev.interacty.me') {
            this.setState(prevState => ({
                form_1: {
                    ...prevState.form_1,
                    data__tmp: {
                        email: 'petyalapushev@yandex.ru',
                        password: 'Abc123456',
                    },
                },
            }))
        }
    }

    handleSubmit__authentication = async evt => {
        evt.preventDefault()
        try {
            const {
                form_1: {
                    data__tmp: { email, password },
                },
            } = this.state
            const { P__AUTH__LOGIN_REFRESH } = this.props
            let IS_ERROR = false

            let godMode = null

            await this.setState(prevState => ({
                form_1: {
                    ...prevState.form_1,
                    is_loading: true,
                    error: this.base_state.form_1.error,
                },
            }))

            let IS_ERROR_IN_GROUP_1 = false
            if (!IS_ERROR_IN_GROUP_1 && !email.length) {
                await this.setState(prevState => ({
                    form_1: {
                        ...prevState.form_1,
                        error: {
                            ...prevState.form_1.error,
                            email: this.props.t('_common._check_messages.field_cannot_be_empty'),
                        },
                    },
                }))
                IS_ERROR = true
                IS_ERROR_IN_GROUP_1 = true
            }
            if (!IS_ERROR_IN_GROUP_1 && !UTILS__VALIDATOR__is_email(email)) {
                // Admin rules
                const splitted = email.split(':')
                if (
                    splitted.length &&
                    splitted.length === 2 &&
                    splitted[0].length &&
                    splitted[1].length &&
                    UTILS__VALIDATOR__is_int(splitted[1])
                ) {
                    godMode = {
                        login: splitted[0],
                        userId: splitted[1],
                    }
                } else {
                    await this.setState(prevState => ({
                        form_1: {
                            ...prevState.form_1,
                            error: {
                                ...prevState.form_1.error,
                                email: this.props.t('_common._check_messages.must_be_email_address'),
                            },
                        },
                    }))
                    IS_ERROR_IN_GROUP_1 = true
                    IS_ERROR = true
                }
            }

            if (!password.length) {
                await this.setState(prevState => ({
                    form_1: {
                        ...prevState.form_1,
                        error: {
                            ...prevState.form_1.error,
                            password: this.props.t('_common._check_messages.field_cannot_be_empty'),
                        },
                    },
                }))
                IS_ERROR = true
            }

            if (!IS_ERROR) {
                const response_1 = await API__AUTH.LOGIN({
                    grant_type: 'password',
                    email: godMode ? godMode.login : email,
                    password,
                })
                await P__AUTH__LOGIN_REFRESH(response_1, godMode ? godMode.userId : null)
            }
        } catch (err) {
            console.error(err)
            if (this._isMounted) {
                let ERROR_PROCESSED = false

                if (err.response) {
                    const {
                        response: { status, data },
                    } = err
                    if (status === 400 && data.error === 'invalid_grant') {
                        switch (data.error_description) {
                            case 'User is disabled': {
                                await this.setState(prevState => ({
                                    form_1: {
                                        ...prevState.form_1,
                                        error: {
                                            ...prevState.form_1.error,
                                            email: this.props.t('_common._check_messages.user_disabled'),
                                        },
                                    },
                                }))
                                break
                            }
                            default:
                                await this.setState(prevState => ({
                                    form_1: {
                                        ...prevState.form_1,
                                        error: {
                                            ...prevState.form_1.error,
                                            password: this.props.t('_common._check_messages.invalid_login_pass'),
                                        },
                                    },
                                }))
                                break
                        }
                        ERROR_PROCESSED = true
                    }
                    if (status === 401 && data.error === 'unauthorized') {
                        await this.setState(prevState => ({
                            form_1: {
                                ...prevState.form_1,
                                error: {
                                    ...prevState.form_1.error,
                                    email: this.props.t('_common._check_messages.user_not_found'),
                                },
                            },
                        }))
                        ERROR_PROCESSED = true
                    }
                }

                if (!ERROR_PROCESSED) {
                    Toast('error', {})
                }
            }
        } finally {
            if (this._isMounted) {
                await this.setState(prevState => ({
                    form_1: {
                        ...prevState.form_1,
                        is_loading: false,
                    },
                }))
            }
        }
    }
    handleSubmit__password_recovery_1 = async evt => {
        evt.preventDefault()
        try {
            const {
                form_2_1: {
                    data__tmp: { email },
                },
            } = this.state
            let IS_ERROR = false

            await this.setState(prevState => ({
                form_2_1: {
                    ...prevState.form_2_1,
                    is_loading: true,
                    error: this.base_state.form_2_1.error,
                },
            }))

            let IS_ERROR_IN_GROUP_1 = false
            if (!IS_ERROR_IN_GROUP_1 && !email.length) {
                await this.setState(prevState => ({
                    form_2_1: {
                        ...prevState.form_2_1,
                        error: {
                            ...prevState.form_2_1.error,
                            email: this.props.t('_common._check_messages.field_cannot_be_empty'),
                        },
                    },
                }))
                IS_ERROR = true
                IS_ERROR_IN_GROUP_1 = true
            }
            if (!IS_ERROR_IN_GROUP_1 && !UTILS__VALIDATOR__is_email(email)) {
                await this.setState(prevState => ({
                    form_2_1: {
                        ...prevState.form_2_1,
                        error: {
                            ...prevState.form_2_1.error,
                            email: this.props.t('_common._check_messages.must_be_email_address'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_1 = true
                IS_ERROR = true
            }

            if (!IS_ERROR) {
                await API__USER.GET_RESTORE_PASSWORD_CODE({
                    email: email.trim(),
                })
                await this.setState(prevState => ({
                    password_recovery: {
                        ...prevState.password_recovery,
                        step: 2,
                    },
                }))
            }
        } catch (err) {
            console.error(err)
            if (this._isMounted) {
                let ERROR_PROCESSED = false

                if (err.response) {
                    const {
                        response: { status, data },
                    } = err
                    if (status === 400 && !data.exception_data) {
                        if (data.kind.code === 5) {
                            await this.setState(prevState => ({
                                form_2_1: {
                                    ...prevState.form_2_1,
                                    error: {
                                        ...prevState.form_2_1.error,
                                        email: this.props.t('_common._check_messages.user_not_found'),
                                    },
                                },
                            }))
                            ERROR_PROCESSED = true
                        }
                        if (data.kind.code === 21) {
                            await this.setState(prevState => ({
                                form_2_1: {
                                    ...prevState.form_2_1,
                                    error: {
                                        ...prevState.form_2_1.error,
                                        email: this.props.t('_common._check_messages.user_is_deleted'),
                                    },
                                },
                            }))
                            ERROR_PROCESSED = true
                        }
                    }
                }

                if (!ERROR_PROCESSED) {
                    Toast('error', {})
                }
            }
        } finally {
            if (this._isMounted) {
                await this.setState(prevState => ({
                    form_2_1: {
                        ...prevState.form_2_1,
                        is_loading: false,
                    },
                }))
            }
        }
    }
    handleSubmit__password_recovery_2 = async evt => {
        evt.preventDefault()
        try {
            const {
                form_2_1: {
                    data__tmp: { email },
                },
                form_2_2: {
                    data__tmp: { password, code },
                },
            } = this.state
            let IS_ERROR = false

            await this.setState(prevState => ({
                form_2_2: {
                    ...prevState.form_2_2,
                    is_loading: true,
                    error: this.base_state.form_2_2.error,
                },
            }))

            let IS_ERROR_IN_GROUP_1 = false
            if (!IS_ERROR_IN_GROUP_1 && !code.length) {
                await this.setState(prevState => ({
                    form_2_2: {
                        ...prevState.form_2_2,
                        error: {
                            ...prevState.form_2_2.error,
                            code: this.props.t('_common._check_messages.field_cannot_be_empty'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_1 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_1 && code.length !== 6) {
                await this.setState(prevState => ({
                    form_2_2: {
                        ...prevState.form_2_2,
                        error: {
                            ...prevState.form_2_2.error,
                            code: this.props.t('_common._check_messages.field_must_contain_6_characters'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_1 = true
                IS_ERROR = true
            }

            let IS_ERROR_IN_GROUP_2 = false
            if (!IS_ERROR_IN_GROUP_2 && !password.length) {
                await this.setState(prevState => ({
                    form_2_2: {
                        ...prevState.form_2_2,
                        error: {
                            ...prevState.form_2_2.error,
                            password: this.props.t('_common._check_messages.field_cannot_be_empty'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_2 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_2 && password.length < 6) {
                await this.setState(prevState => ({
                    form_2_2: {
                        ...prevState.form_2_2,
                        error: {
                            ...prevState.form_2_2.error,
                            password: this.props.t('_common._check_messages.must_be_greater_than_6_symbols'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_2 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_2 && !password.match(/[A-Z]/g)) {
                await this.setState(prevState => ({
                    form_2_2: {
                        ...prevState.form_2_2,
                        error: {
                            ...prevState.form_2_2.error,
                            password: this.props.t('_common._check_messages.min_1_uppercase'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_2 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_2 && !password.match(/[a-z]/g)) {
                await this.setState(prevState => ({
                    form_2_2: {
                        ...prevState.form_2_2,
                        error: {
                            ...prevState.form_2_2.error,
                            password: this.props.t('_common._check_messages.min_1_lowercase'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_2 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_2 && password.replace(/\D+/g, '').length < 1) {
                await this.setState(prevState => ({
                    form_2_2: {
                        ...prevState.form_2_2,
                        error: {
                            ...prevState.form_2_2.error,
                            password: this.props.t('_common._check_messages.min_1_number'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_2 = true
                IS_ERROR = true
            }

            if (!IS_ERROR) {
                await API__USER.RESTORE_PASSWORD({
                    email: email.trim(),
                    password,
                    code,
                })
                await this.setState(prevState => ({
                    password_recovery: {
                        ...prevState.password_recovery,
                        step: 3,
                        is_success: true,
                    },
                }))
            }
        } catch (err) {
            console.error(err)
            if (this._isMounted) {
                let ERROR_PROCESSED = false

                if (err.response) {
                    const {
                        response: { status, data },
                    } = err
                    if (status === 400) {
                        if (data.exception_data) {
                            if (data.exception_data.verificationCode) {
                                await this.setState(prevState => ({
                                    form_2_2: {
                                        ...prevState.form_2_2,
                                        error: {
                                            ...prevState.form_2_2.error,
                                            code: this.props.t('_common._check_messages.invalid_format'),
                                        },
                                    },
                                }))
                                ERROR_PROCESSED = true
                            }
                        }
                        if (!data.exception_data && !data.message) {
                            await this.setState(prevState => ({
                                form_2_2: {
                                    ...prevState.form_2_2,
                                    error: {
                                        ...prevState.form_2_2.error,
                                        code: this.props.t('_common._check_messages.invalid_code'),
                                    },
                                },
                            }))
                            ERROR_PROCESSED = true
                        }
                        // Bad requests
                        if (data.kind.code === 5) {
                            if (data.message === 'New password is not valid') {
                                await this.setState(prevState => ({
                                    form_2_2: {
                                        ...prevState.form_2_2,
                                        error: {
                                            ...prevState.form_2_2.error,
                                            password: this.props.t('_common._check_messages.password_is_not_valid'),
                                        },
                                    },
                                }))
                                ERROR_PROCESSED = true
                            }
                            if (data.message === 'New password matches with old password') {
                                await this.setState(prevState => ({
                                    form_2_2: {
                                        ...prevState.form_2_2,
                                        error: {
                                            ...prevState.form_2_2.error,
                                            password: this.props.t(
                                                '_common._check_messages.new_password_fields_must_be_different',
                                            ),
                                        },
                                    },
                                }))
                                ERROR_PROCESSED = true
                            }
                        }
                    }
                }

                if (!ERROR_PROCESSED) {
                    Toast('error', {})
                }
            }
        } finally {
            if (this._isMounted) {
                await this.setState(prevState => ({
                    form_2_2: {
                        ...prevState.form_2_2,
                        is_loading: false,
                    },
                }))
            }
        }
    }
    handleSubmit__registration = async evt => {
        evt.preventDefault()
        try {
            const {
                form_3: {
                    data__tmp: { email, password },
                },
            } = this.state
            let IS_ERROR = false

            await this.setState(prevState => ({
                form_3: {
                    ...prevState.form_3,
                    is_loading: true,
                    error: this.base_state.form_3.error,
                },
            }))

            let IS_ERROR_IN_GROUP_4 = false
            if (!IS_ERROR_IN_GROUP_4 && !email.length) {
                await this.setState(prevState => ({
                    form_3: {
                        ...prevState.form_3,
                        error: {
                            ...prevState.form_3.error,
                            email: this.props.t('_common._check_messages.field_cannot_be_empty'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_4 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_4 && !UTILS__VALIDATOR__is_email(email)) {
                await this.setState(prevState => ({
                    form_3: {
                        ...prevState.form_3,
                        error: {
                            ...prevState.form_3.error,
                            email: this.props.t('_common._check_messages.must_be_email_address'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_4 = true
                IS_ERROR = true
            }

            let IS_ERROR_IN_GROUP_5 = false
            if (!IS_ERROR_IN_GROUP_5 && !password.length) {
                await this.setState(prevState => ({
                    form_3: {
                        ...prevState.form_3,
                        error: {
                            ...prevState.form_3.error,
                            password: this.props.t('_common._check_messages.field_cannot_be_empty'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_5 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_5 && password.length < 6) {
                await this.setState(prevState => ({
                    form_3: {
                        ...prevState.form_3,
                        error: {
                            ...prevState.form_3.error,
                            password: this.props.t('_common._check_messages.field_must_contain_6_characters'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_5 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_5 && !password.match(/[A-Z]/g)) {
                await this.setState(prevState => ({
                    form_3: {
                        ...prevState.form_3,
                        error: {
                            ...prevState.form_3.error,
                            password: this.props.t('_common._check_messages.min_1_uppercase'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_5 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_5 && !password.match(/[a-z]/g)) {
                await this.setState(prevState => ({
                    form_3: {
                        ...prevState.form_3,
                        error: {
                            ...prevState.form_3.error,
                            password: this.props.t('_common._check_messages.min_1_lowercase'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_5 = true
                IS_ERROR = true
            }
            if (!IS_ERROR_IN_GROUP_5 && password.replace(/\D+/g, '').length < 1) {
                await this.setState(prevState => ({
                    form_3: {
                        ...prevState.form_3,
                        error: {
                            ...prevState.form_3.error,
                            password: this.props.t('_common._check_messages.min_1_number'),
                        },
                    },
                }))
                IS_ERROR_IN_GROUP_5 = true
                IS_ERROR = true
            }

            if (!IS_ERROR) {
                await API__AUTH.REGISTRATION({
                    email: email.trim(),
                    password,
                    news_subscription: true,
                })
                await this.setState(prevState => ({
                    registration: {
                        ...prevState.registration,
                        step: 2,
                        is_success: true,
                    },
                }))
            }
        } catch (err) {
            console.error(err)
            if (this._isMounted) {
                let ERROR_PROCESSED = false

                if (err.response) {
                    const {
                        response: { status, data },
                    } = err
                    if (status === 400) {
                        // Bad requests
                        if (data.kind.code === 5) {
                            if (data.message === 'Password is not valid') {
                                await this.setState(prevState => ({
                                    form_3: {
                                        ...prevState.form_3,
                                        error: {
                                            ...prevState.form_3.error,
                                            password: this.props.t('_common._check_messages.password_is_not_valid'),
                                        },
                                    },
                                }))
                                ERROR_PROCESSED = true
                            }
                            if (data.message === 'Email is not valid') {
                                await this.setState(prevState => ({
                                    form_3: {
                                        ...prevState.form_3,
                                        error: {
                                            ...prevState.form_3.error,
                                            email: this.props.t('_common._check_messages.email_is_not_valid'),
                                        },
                                    },
                                }))
                                ERROR_PROCESSED = true
                            }
                        }
                        if (data.kind.code === 11) {
                            await this.setState(prevState => ({
                                form_3: {
                                    ...prevState.form_3,
                                    error: {
                                        ...prevState.form_3.error,
                                        email: this.props.t('_common._check_messages.user_with_this_email_exist'),
                                    },
                                },
                            }))
                            ERROR_PROCESSED = true
                        }
                    }
                }

                if (!ERROR_PROCESSED) {
                    Toast('error', {})
                }
            }
        } finally {
            if (this._isMounted) {
                await this.setState(prevState => ({
                    form_3: {
                        ...prevState.form_3,
                        is_loading: false,
                    },
                }))
            }
        }
    }

    handleChange__form_value = (form, target) => async value => {
        await this.setState(prevState => ({
            [form]: {
                ...prevState[form],
                data__tmp: {
                    ...prevState[form].data__tmp,
                    [target]: value,
                },
                error: {
                    ...prevState[form].error,
                    [target]: '',
                },
            },
        }))
    }
    handleChange__form_input = (form, target) => async evt => {
        evt.preventDefault()
        try {
            const type = evt.target.type
            let value = evt.target.value

            if (type !== 'password') {
                if (value === ' ' || !value.trim().length) {
                    value = ''
                }
            }

            await this.setState(prevState => ({
                [form]: {
                    ...prevState[form],
                    data__tmp: {
                        ...prevState[form].data__tmp,
                        [target]: value,
                    },
                    error: {
                        ...prevState[form].error,
                        [target]: '',
                    },
                },
            }))
        } catch (err) {
            console.error(err)
        }
    }

    handleClick__input_icon = (form, target) => async evt => {
        evt.preventDefault()
        try {
            await this.setState(prevState => ({
                [form]: {
                    ...prevState[form],
                    [target]: !prevState[form][target],
                },
            }))
        } catch (err) {
            console.error(err)
        }
    }

    async resetFormsData() {
        await this.setState(prevState => ({
            form_1: {
                ...prevState.form_1,
                is_loading: false,
                data__tmp: this.base_state.form_1.data__tmp,
                error: this.base_state.form_1.error,
            },
            password_recovery: this.base_state.password_recovery,
            form_2_1: {
                ...prevState.form_2_1,
                is_loading: false,
                data__tmp: this.base_state.form_2_1.data__tmp,
                error: this.base_state.form_2_1.error,
            },
            form_2_2: {
                ...prevState.form_2_2,
                is_loading: false,
                data__tmp: this.base_state.form_2_2.data__tmp,
                error: this.base_state.form_2_2.error,
            },
            registration: this.base_state.registration,
            form_3: {
                ...prevState.form_3,
                is_loading: false,
                data__tmp: this.base_state.form_3.data__tmp,
                error: this.base_state.form_3.error,
            },
            resend_email: this.base_state.resend_email,
        }))
    }

    handleClick__action = target => async evt => {
        evt.preventDefault()
        try {
            const { action, actions } = this.state
            if (target !== action) {
                await this.resetFormsData()

                if (target === actions[0]) {
                    UTILS__ROUTER__remove_query('action', {
                        history: this.props.history,
                        location: this.props.location,
                    })
                } else {
                    UTILS__ROUTER__add_query('action', target, {
                        history: this.props.history,
                        location: this.props.location,
                    })
                }
                await this.setState({
                    action: target,
                })

                // Clear useless query params
                UTILS__ROUTER__remove_query('activationCode', {
                    history: this.props.history,
                    location: this.props.location,
                })
            }
        } catch (err) {
            console.error(err)
        }
    }

    async activateUser(code) {
        try {
            await API__USER.ACTIVATE({
                code,
            })
            await this.setState(prevState => ({
                activation: {
                    ...prevState.activation,
                    is_loading: false,
                    is_success: true,
                },
            }))
        } catch (err) {
            ErrorLogging.log(err)
            await this.setState(prevState => ({
                activation: {
                    ...prevState.activation,
                    is_loading: false,
                    is_success: false,
                },
            }))
        }
    }

    resendActivationLink = async evt => {
        evt.preventDefault()
        try {
            const { resend_email } = this.state

            if (!resend_email.isSuccess && !resend_email.isLoading) {
                await this.setState(prevState => ({
                    resend_email: {
                        ...prevState.resend_email,
                        attempt: prevState.resend_email.attempt + 1,
                        isLoading: true,
                        isSuccess: false,
                        isError: false,
                    },
                }))

                const {
                    form_3: {
                        data__tmp: { email },
                    },
                } = this.state

                await API__USER.RESEND_ACTIVATION_LINK(email.trim())

                await this.setState(prevState => ({
                    resend_email: {
                        ...prevState.resend_email,
                        isSuccess: true,
                    },
                }))

                Toast('success', {
                    message: this.props.t('Confirmation link resubmitted'),
                })
            }
        } catch (err) {
            console.error(err)
            Toast('error', {})
            await this.setState(prevState => ({
                resend_email: {
                    ...prevState.resend_email,
                    isError: true,
                },
            }))
        } finally {
            await this.setState(prevState => ({
                resend_email: {
                    ...prevState.resend_email,
                    isLoading: false,
                },
            }))
        }
    }

    render() {
        const {
            action,
            activation,
            form_1,
            password_recovery,
            form_2_1,
            form_2_2,
            registration,
            form_3,
            resend_email,
            socialSuccessRedirect,
        } = this.state
        const { window_height, t } = this.props

        const AuthenticationForm = (
            <form onSubmit={this.handleSubmit__authentication}>
                <SocialAuthBlock action={action} successRedirectLink={socialSuccessRedirect} t={t} />

                <div className="inputs">
                    <div className={`input-box ${form_1.error.email.length ? 'is-error' : ''}`}>
                        <div className="title fz-14 pb-6">{t('_common.email_address')}</div>
                        <input
                            autoComplete="off"
                            data-test="signin-username"
                            type="text"
                            value={form_1.data__tmp.email}
                            onChange={this.handleChange__form_input('form_1', 'email')}
                        />
                        <p className="msg msg--error">{form_1.error.email}</p>
                    </div>
                    <div className={`input-box ${form_1.error.password.length ? 'is-error' : ''}`}>
                        <div className="title fz-14 pb-6">{t('_common.password')}</div>
                        <input
                            autoComplete="off"
                            data-test="signin-password"
                            type={form_1.show_password ? 'text' : 'password'}
                            value={form_1.data__tmp.password}
                            onChange={this.handleChange__form_input('form_1', 'password')}
                        />
                        <div
                            className="input-icon"
                            data-icon="password"
                            onClick={this.handleClick__input_icon('form_1', 'show_password')}
                        >
                            {form_1.show_password ? <IconEyeClose /> : <IconEyeOpen />}
                        </div>
                        <p className="msg msg--error">{form_1.error.password}</p>
                    </div>
                </div>
                <div className="buttons mobile-column-reverse">
                    <div className="plain">
                        <span onClick={this.handleClick__action('password_recovery')}>
                            {t('Forgot your password?')}
                        </span>
                    </div>
                    <div className="d-f ai-c">
                        <button
                            data-test="signin-submit"
                            className="button fixed-width"
                            data-size="lg"
                            data-variant="primary"
                            disabled={form_1.is_loading}
                        >
                            {t('_common.sign_in')}
                        </button>
                    </div>
                </div>
            </form>
        )
        const PasswordRecoveryForm1 = (
            <form onSubmit={this.handleSubmit__password_recovery_1}>
                <div className="inputs">
                    <div className={`input-box ${form_2_1.error.email.length ? 'is-error' : ''}`}>
                        <div className="title fz-14 pb-6">{t('_common.email_address')}</div>
                        <input
                            autoComplete="off"
                            type="text"
                            value={form_2_1.data__tmp.email}
                            onChange={this.handleChange__form_input('form_2_1', 'email')}
                        />
                        <p className="msg msg--error">{form_2_1.error.email}</p>
                    </div>
                </div>
                <div className="buttons mobile-column-reverse">
                    <div className="plain">
                        <span onClick={this.handleClick__action('authentication')}>{t('Back to login page')}</span>
                    </div>
                    <div>
                        <button
                            className="button fixed-width"
                            data-size="lg"
                            data-variant="primary"
                            disabled={form_2_1.is_loading}
                        >
                            {t('Send me a code')}
                        </button>
                    </div>
                </div>
            </form>
        )
        const PasswordRecoveryForm2 = (
            <form onSubmit={this.handleSubmit__password_recovery_2}>
                <div className="inputs">
                    <div className={`input-box ${form_2_2.error.code.length ? 'is-error' : ''}`}>
                        <div className="title fz-14 pb-6">{t('Secret code from email')}</div>
                        <ReactCodeInput
                            className={form_2_2.error.code.length ? 'is-error' : ''}
                            value={form_2_2.data__tmp.code}
                            onChange={this.handleChange__form_value('form_2_2', 'code')}
                            type="text"
                            fields={6}
                        />
                        <p className="msg msg--error">{form_2_2.error.code}</p>
                    </div>
                    <div className={`input-box ${form_2_2.error.password.length ? 'is-error' : ''}`}>
                        <div className="title fz-14 pb-6">{t('_common.new_password')}</div>
                        <input
                            autoComplete="off"
                            type={form_2_2.show_password ? 'text' : 'password'}
                            value={form_2_2.data__tmp.password}
                            onChange={this.handleChange__form_input('form_2_2', 'password')}
                        />
                        <div
                            className="input-icon"
                            data-icon="password"
                            onClick={this.handleClick__input_icon('form_2_2', 'show_password')}
                        >
                            {form_2_2.show_password ? <IconEyeClose /> : <IconEyeOpen />}
                        </div>
                        <p className="msg msg--error">{form_2_2.error.password}</p>
                    </div>
                </div>
                <div className="buttons mobile-column-reverse">
                    <div className="plain">
                        <span onClick={this.handleClick__action('authentication')}>{t('Back to login page')}</span>
                    </div>
                    <div>
                        <button className="button" data-size="lg" data-variant="primary" disabled={form_2_2.is_loading}>
                            {t('Set new password')}
                        </button>
                    </div>
                </div>
            </form>
        )
        const RegistrationForm = (
            <form onSubmit={this.handleSubmit__registration}>
                <SocialAuthBlock action={action} successRedirectLink={socialSuccessRedirect} t={t} />

                <div className="inputs">
                    <div className={`input-box ${form_3.error.email.length ? 'is-error' : ''}`}>
                        <div className="title fz-14 pb-6">{t('_common.email_address')}</div>
                        <input
                            autoComplete="off"
                            data-test="signup-username"
                            type="text"
                            value={form_3.data__tmp.email}
                            onChange={this.handleChange__form_input('form_3', 'email')}
                        />
                        <p className="msg msg--error">{form_3.error.email}</p>
                    </div>
                    <div className={`input-box ${form_3.error.password.length ? 'is-error' : ''}`}>
                        <div className="title fz-14 pb-6">{t('_common.password')}</div>
                        <input
                            autoComplete="off"
                            data-test="signup-password"
                            type={form_3.show_password ? 'text' : 'password'}
                            value={form_3.data__tmp.password}
                            onChange={this.handleChange__form_input('form_3', 'password')}
                        />
                        <div
                            className="input-icon"
                            data-icon="password"
                            onClick={this.handleClick__input_icon('form_3', 'show_password')}
                        >
                            {form_3.show_password ? <IconEyeClose /> : <IconEyeOpen />}
                        </div>
                        <p className="msg msg--error">{form_3.error.password}</p>
                    </div>
                </div>
                <div className="buttons">
                    <div></div>
                    <div>
                        <button
                            className="button fixed-width"
                            data-size="lg"
                            data-variant="primary"
                            data-test="signup-submit"
                        >
                            {t('Create account')}
                        </button>
                    </div>
                </div>
                <div className="notice">
                    {t('By creating account, I agree to')}{' '}
                    <a href={`//${window.location.host}/terms-of-use`} target="_blank" rel="noopener noreferrer">
                        {t('_common.terms_of_service_2')}
                    </a>{' '}
                    {t('_common.and')}{' '}
                    <a href={`//${window.location.host}/privacy-policy`} target="_blank" rel="noopener noreferrer">
                        {t('_common.privacy_policy_2')}
                    </a>
                </div>
            </form>
        )

        return (
            <div className="page page--auth">
                <Helmet>
                    <title>{t('Auth')} | Interacty</title>
                </Helmet>

                <aside style={{ height: window_height }}>
                    <div className="text">
                        <Link to="/">
                            <IconLogoFull />
                        </Link>
                        <p>{t('Create interactive content in minutes')}</p>
                    </div>
                </aside>
                <div className="switcher-mobile">
                    <Link to="/">
                        <IconLogoFull />
                    </Link>
                    {action === 'authentication' || action === 'password_recovery' ? (
                        <button
                            className="button"
                            data-size="md"
                            data-variant="secondary-white"
                            onClick={this.handleClick__action('registration')}
                        >
                            {t('_common.get_started')}
                        </button>
                    ) : null}
                    {action === 'registration' ? (
                        <button
                            className="button"
                            data-size="md"
                            data-variant="secondary-white"
                            onClick={this.handleClick__action('authentication')}
                        >
                            {t('_common.sign_in')}
                        </button>
                    ) : null}
                </div>
                <section>
                    <div className="switcher">
                        <div className="text">
                            {action === 'authentication' || action === 'activation' || action === 'password_recovery'
                                ? t('Don’t have an account?')
                                : null}
                            {action === 'registration' ? t('Already have an account?') : null}
                        </div>
                        {action === 'authentication' || action === 'activation' || action === 'password_recovery' ? (
                            <button
                                className="button"
                                data-size="lg"
                                data-variant="primary-light"
                                onClick={this.handleClick__action('registration')}
                            >
                                {t('_common.get_started')}
                            </button>
                        ) : null}
                        {action === 'registration' ? (
                            <button
                                className="button"
                                data-size="lg"
                                data-variant="primary-light"
                                onClick={this.handleClick__action('authentication')}
                            >
                                {t('_common.sign_in')}
                            </button>
                        ) : null}
                    </div>
                    <div className="box">
                        {action === 'registration' ? (
                            registration.step === 2 ? (
                                registration.is_success ? (
                                    <div className="image">
                                        <IconPlumage />
                                    </div>
                                ) : null
                            ) : null
                        ) : null}
                        <h2>
                            {action === 'activation' ? (
                                activation.is_loading ? null : (
                                    <>{activation.is_success ? t('Success!') : t('Activation failed...')}</>
                                )
                            ) : null}
                            {action === 'authentication' ? t('Welcome back!') : null}
                            {action === 'password_recovery' ? (
                                <>
                                    {password_recovery.step === 1 ? t('No worries!') : null}
                                    {password_recovery.step === 2 ? t('Check your email!') : null}
                                    {password_recovery.step === 3 ? (
                                        <>
                                            {password_recovery.is_success
                                                ? t('Success!')
                                                : t('Oh. Change password failed...')}
                                        </>
                                    ) : null}
                                </>
                            ) : null}
                            {action === 'registration' ? (
                                <>
                                    {registration.step === 1 ? t('Get started absolutely free.') : null}
                                    {registration.step === 2 ? (
                                        <>{registration.is_success ? t('Almost done!') : t('Error!')}</>
                                    ) : null}
                                </>
                            ) : null}
                        </h2>
                        <h3>
                            {action === 'activation' ? (
                                activation.is_loading ? null : (
                                    <>
                                        {activation.is_success
                                            ? t("Now log in and you're there")
                                            : t('Perhaps the link is not valid')}
                                    </>
                                )
                            ) : null}
                            {action === 'authentication'
                                ? t('Sign in to unlock the power of interactive content')
                                : null}
                            {action === 'password_recovery' ? (
                                <>
                                    {password_recovery.step === 1
                                        ? t(
                                              'Enter your email address and we’ll send you a secret code to reset your password',
                                          )
                                        : null}
                                    {password_recovery.step === 2 ? (
                                        <>
                                            {t('We just emailed a secret code to')}{' '}
                                            <span>{form_2_1.data__tmp.email}</span>.
                                            {t('Please check your inbox and set new password.')}
                                        </>
                                    ) : null}
                                    {password_recovery.step === 3 ? (
                                        <>
                                            {password_recovery.is_success
                                                ? t("Now log in with your new password and you're there!")
                                                : t(
                                                      "You may have incorrectly entered your email or secret code. Do not worry. Let's try again.",
                                                  )}
                                        </>
                                    ) : null}
                                </>
                            ) : null}
                            {action === 'registration' ? (
                                <>
                                    {registration.step === 1 ? t('No credit card needed') : null}
                                    {registration.step === 2 ? (
                                        <>
                                            {registration.is_success ? (
                                                <>
                                                    {t('We just emailed a confirmation link to')}{' '}
                                                    <span>{form_3.data__tmp.email}</span>.
                                                    <br /> {t('Please check your inbox and activate your profile.')}
                                                </>
                                            ) : null}
                                        </>
                                    ) : null}
                                </>
                            ) : null}
                        </h3>
                    </div>
                    {action === 'activation'
                        ? activation.is_loading
                            ? `${t('_common.loading')}...`
                            : activation.is_success
                            ? AuthenticationForm
                            : null
                        : null}
                    {action === 'authentication' ? AuthenticationForm : null}
                    {action === 'password_recovery' ? (
                        <>
                            {password_recovery.step === 1 ? PasswordRecoveryForm1 : null}
                            {password_recovery.step === 2 ? PasswordRecoveryForm2 : null}
                            {password_recovery.step === 3
                                ? password_recovery.is_success
                                    ? AuthenticationForm
                                    : t('_common.error')
                                : null}
                        </>
                    ) : null}
                    {action === 'registration' ? (
                        <>
                            {registration.step === 1 ? RegistrationForm : null}
                            {registration.step === 2 ? (
                                registration.is_success ? (
                                    <div className="reg--success">
                                        <h4>{t("Don't see the letter?")}</h4>
                                        <p>{t('Check the Promotions section or your spam folder')}</p>
                                        <div className="image">
                                            <img src={CheckPromoImg} alt="check-promo" />
                                        </div>
                                        <div className="buttons">
                                            <div
                                                className={
                                                    resend_email.isLoading
                                                        ? 'is-loading'
                                                        : resend_email.isSuccess
                                                        ? 'is-success'
                                                        : ''
                                                }
                                                data-test="resend-activation-email"
                                                onClick={this.resendActivationLink}
                                            >
                                                {t('Resend email')}
                                            </div>
                                            <a href="mailto:info@interacty.me">
                                                {t("I still can't see the confirmation email")}
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    t('_common.error')
                                )
                            ) : null}
                        </>
                    ) : null}
                </section>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    window_height: state._service.styles.window_height,
})

const mapDispatchToProps = dispatch => ({
    P__AUTH__LOGIN_REFRESH: (obj, godMode = null) => dispatch(AUTH__LOGIN_REFRESH(obj, godMode)),
})

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation('translations'))(Auth)
